import { Row } from "@components/Flex";
import { NoDataDisclaimer } from "@components/Goals/NoDataDisclaimer";
import { Spacing, SpacingSizes } from "@components/Spacing";
import { Body } from "@components/Typography";
import { BeneficiaryType } from "@ctypes";
import { useGoalsContext } from "@hooks";
import { i18n, Translations } from "@i18n";
import { AccountBalanceCard } from "./AccountBalanceCard";
import { useStyles } from "./styles";
import { AccountsSectionProps } from "./types";

export const AccountsSection = ({ style }: AccountsSectionProps) => {
  const styles = useStyles();

  const { beneficiary, goal } = useGoalsContext();

  const goalAccounts =
    goal?.accounts?.map((g) => ({
      accountType: g?.type,
      balanceInCents: g?.balanceInCents,
      accountHolder:
        beneficiary?.type === BeneficiaryType.Self
          ? i18n.t(Translations.AccountsSectionMeLabel)
          : beneficiary?.firstName,
    })) ?? [];

  const partnerAccounts =
    goal?.partners?.map((p) => ({
      accountType: p?.accountType,
      balanceInCents: p?.currentAmountInCents,
      accountHolder: p?.firstName,
    })) ?? [];

  const accounts = [...goalAccounts, ...partnerAccounts];

  const content = (() => {
    if (!accounts.length) {
      return (
        <>
          <Spacing size={SpacingSizes.M} />
          <NoDataDisclaimer />
        </>
      );
    }

    return (
      <Row style={styles.inner}>
        {accounts.map((account) => (
          <AccountBalanceCard
            accountType={account.accountType}
            balanceInCents={account.balanceInCents}
            accountHolder={account.accountHolder}
            style={styles.spacing}
          />
        ))}
      </Row>
    );
  })();

  return (
    <div style={{ ...styles.container, ...style }}>
      <Body style={styles.title}>{i18n.t(Translations.AccountsSectionTitle)}</Body>

      {content}
    </div>
  );
};
